import { QueryDocumentSnapshot, addDoc, collection, getDocs, getFirestore, limit, orderBy, query, serverTimestamp, startAfter } from 'firebase/firestore';
import InputButton from '../../reusable-components/buttons/input-button';
import VideoBrowser from '../../reusable-components/video-browser/video-browser';
import { useEffect, useState } from 'react';
import HighScores from '../../reusable-components/high-scores/high-scores';
import { initializeApp } from 'firebase/app';
import './game-over-screen.scss';

interface  GameOverScreenProps {
  finalScore: number;
  videoHistory: VideoInfo[][];
  gameMode: GameMode;
  averageRoundScores: RoundScores;
}

/**
 * The screen displayed when a game is over, showing the final scores, high scores, video history, and high score submission element
 * @property {number} finalScore - The final score achieved in the game.
 * @property {VideoInfo[][]} videoHistory - A nested array containing video information for each round played.
 * @property {GameMode} gameMode - The current game mode
 * @property {RoundScores} averageRoundScores - Average scores for each round's certainty and independence.
 */
const GameOverScreen: React.FC<GameOverScreenProps> = ({videoHistory, finalScore,  gameMode, averageRoundScores}) => {
  return (
    <div className="game-over-screen">
      <div className="top-section"> 
        <div className="game-over-title">GAME OVER</div>
        <div className="score-row">
          <div className="game-over-score">
            <div className="final-score">Final Score: 
              <span className="score">{finalScore}</span>
            </div>
            <div className="average-scores">
              <div>Average Accuracy: <span>{Math.round(averageRoundScores.certainty * 100) / 100}</span></div>
              <div>Average Independence: <span>{Math.round(averageRoundScores.independence * 100) / 100}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"> 
        <div className="video-history-container">
          <VideoBrowser videoHistory={videoHistory}/>
        </div>
      </div>
    </div>
  )
}

export default GameOverScreen;